export const DASHBOARD_RINGS = {
  documentWithFindgins: 7,
  documentWithoutFindings: 38,
  usersWithIssues: 2,
  usersWithoutIssues: 6,
  applications: 4,
  policyViolationsLLM: 14,
  policyViolationsApplications: 7,
};
